import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import classnames from "classnames";
import { Helmet } from "react-helmet";

import styles from "./blending.module.css";
import { useImgLoaded } from "../../hooks/CustomHooks";
import { useQuery, useBackground } from "../../hooks/QueryHooks";
import * as blendingActions from "../../redux/actions/blending";
import { srcPath } from "../../util/Path";
import { maxLeft } from "../../util/Constants";
import { State } from "../../redux/store";
import { backToWeb, pageTitle } from "../../util/Util";
import Placeholder from "../../components/Placeholder";
import Logo from "../../components/Logo";
import GamePage from "./GamePage";
import FinishBoard from "./FinishBoard";

interface Props {
  itemLeft: number;
  scale: number;
  ratio: number;
}

const BlendingGame = (props: Props) => {
  const { itemLeft, scale, ratio } = props;
  const dispatch = useDispatch();
  useQuery();

  const { queryLoaded, grade, unit, webUrl, gameConfigLoaded } = useSelector(
    (state: State) => state.shared
  );
  const { alphabets, words, isFinished } = useSelector(
    (state: State) => state.blending
  );
  const [imgLoaded, addImgLoaded] = useImgLoaded(2);
  const background = useBackground(grade, "blending");

  useEffect(() => {
    if (queryLoaded && grade && unit) {
      dispatch(blendingActions.importWords(grade, unit));
    }
  }, [queryLoaded]);

  if (!queryLoaded) return <Placeholder type="loading" />;
  if (!grade || !unit) return <Placeholder type="invalid" />;
  if (!gameConfigLoaded) return <Placeholder type="loading" />;
  if (!alphabets.length || !words.length) return <Placeholder type="invalid" />;

  return (
    <>
      <Helmet>
        <title>
          {pageTitle("Blending Game", `Sound Books Unit ${unit}`, grade)}
        </title>
      </Helmet>
      <div style={{ display: imgLoaded ? "block" : "none" }}>
        <img className="bg" src={background} alt="" onLoad={addImgLoaded} />
        <Logo grade={grade} unit={unit} left={itemLeft} style={{ zIndex: 0 }} />
        <img
          className={classnames("abs", "btn", "main-btn", styles.topRightBack)}
          style={{
            right: `${itemLeft > maxLeft ? maxLeft : itemLeft + 30}px`,
          }}
          src={srcPath("shared/back.png")}
          alt=""
          onLoad={addImgLoaded}
          onClick={() => backToWeb("sound_book", webUrl, grade, unit)}
        />
        <GamePage itemLeft={itemLeft} ratio={ratio} />
        {isFinished && <FinishBoard scale={scale} left={itemLeft} />}
      </div>
    </>
  );
};

export default BlendingGame;
